var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Comment',_vm._b({staticClass:"comments-action",attrs:{"auto-complete":_vm.autoComplete,"resource-type":_vm.resourceType,"editor":true,"user-data":_vm.userData,"resource-id":_vm.resourceId},on:{"new":_vm.onNewComment}},'Comment',_vm.editorData,false))
}
var staticRenderFns = []

export { render, staticRenderFns }